import * as types from './mutation-types.js'
import analytics from '@/services/api/analytics.js'
import { getAnalyticsOptions } from '../../helpers'

// initial state
const state = () => ({
  total: 0
})

// getters
const getters = {

}

// actions
const actions = {
  async getDownloads ({ commit, rootState, rootGetters }, compare) {
    commit(types.CLEAR_DOWNLOAD_TOTAL)
    const options = getAnalyticsOptions(rootState, rootGetters, compare)
    await analytics.getDownloads(options).then((data) => {
      commit(types.SET_DOWNLOAD_TOTAL, data.total)
      commit('ADD_API_CALLS', {
        downloads: {
          href: data.href,
          time: new Date().toUTCString()
        }
      }, { root: true })
      // todo: this endpoint obviously returns a lot more, do that when we move downloads page to vuex
    })
  }
}

// mutations
const mutations = {
  [types.CLEAR_DOWNLOAD_TOTAL] (state) {
    state.total = 0
  },
  [types.SET_DOWNLOAD_TOTAL] (state, total) {
    state.total = total
  }
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
}
